(function () {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let observer;
  let leaving = false;

  function finishSkeleton(host) {
    if (host.classList.contains('is-dt-skeleton-loaded')) return;
    host.classList.add('is-dt-skeleton-loaded');
    host.setAttribute('aria-busy', 'false');
  }

  function initSkeletons() {
    const hosts = document.querySelectorAll('[data-dt-skeleton-host]:not([data-dt-skeleton-ready])');

    hosts.forEach((host) => {
      host.dataset.dtSkeletonReady = 'true';
      host.setAttribute('aria-busy', 'true');
      const image = host.querySelector('img');

      if (!image) {
        finishSkeleton(host);
        return;
      }

      const reveal = async () => {
        try {
          await image.decode();
        } catch (error) {
          // A loaded image can reject decode in older browsers; the visual is still safe to reveal.
        }
        finishSkeleton(host);
      };

      if (image.complete) {
        reveal();
      } else {
        image.addEventListener('load', reveal, { once: true });
        image.addEventListener('error', () => finishSkeleton(host), { once: true });
      }
    });
  }

  function reveal(entry) {
    entry.target.classList.add('is-visible');
    observer?.unobserve(entry.target);
  }

  function initMotion() {
    if (!document.querySelector('[data-dt-gifting-motion-page]')) return;

    initSkeletons();

    const items = Array.from(document.querySelectorAll('[data-dt-motion-item]:not([data-dt-motion-ready])'));
    if (!items.length) return;

    if (!reduceMotion.matches && 'IntersectionObserver' in window && !observer) {
      observer = new IntersectionObserver(
        (entries) => entries.forEach((entry) => entry.isIntersecting && reveal(entry)),
        { rootMargin: '80px 0px', threshold: 0.05 }
      );
    }

    let visibleIndex = 0;
    let lazyIndex = 0;

    items.forEach((item) => {
      item.dataset.dtMotionReady = 'true';

      if (reduceMotion.matches) return;

      const isBelowFold = item.hasAttribute('data-dt-motion-card') && item.getBoundingClientRect().top > window.innerHeight + 80;
      if (isBelowFold && observer) {
        item.style.setProperty('--dt-motion-index', lazyIndex % 4);
        lazyIndex += 1;
        item.classList.add('dt-motion-lazy');
        observer.observe(item);
        return;
      }

      item.style.setProperty('--dt-motion-index', visibleIndex);
      visibleIndex += 1;
      if (!item.hasAttribute('data-dt-skeleton-host')) {
        item.classList.add('dt-motion-enter');
      }
    });
  }

  function isEligibleLink(event, link) {
    if (!link || event.defaultPrevented || event.button !== 0) return false;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;
    if (link.target && link.target !== '_self') return false;
    if (link.hasAttribute('download') || link.getAttribute('href')?.startsWith('#')) return false;
    if (window.Shopify?.designMode || reduceMotion.matches) return false;

    const destination = new URL(link.href, window.location.href);
    return destination.origin === window.location.origin && destination.href !== window.location.href;
  }

  function leavePage(event) {
    const link = event.target.closest('[data-dt-motion-link], [data-dt-motion-card] a[href]');
    if (!isEligibleLink(event, link) || leaving) return;

    event.preventDefault();
    leaving = true;

    const visibleItems = Array.from(document.querySelectorAll('[data-dt-motion-item]')).filter((item) => {
      const rect = item.getBoundingClientRect();
      return !item.hidden && rect.bottom > 0 && rect.top < window.innerHeight;
    });

    visibleItems
      .sort((first, second) => {
        const firstRect = first.getBoundingClientRect();
        const secondRect = second.getBoundingClientRect();
        return firstRect.top - secondRect.top || firstRect.left - secondRect.left;
      })
      .forEach((item, index) => item.style.setProperty('--dt-exit-index', index));

    document.documentElement.classList.add('dt-gifting-is-leaving');
    window.setTimeout(() => window.location.assign(link.href), 340 + Math.min(visibleItems.length, 6) * 45);
  }

  if (!window.dtGiftingMotionLoaded) {
    window.dtGiftingMotionLoaded = true;
    document.addEventListener('click', leavePage);
    document.addEventListener('DOMContentLoaded', initMotion, { once: true });
    document.addEventListener('shopify:section:load', initMotion);
    window.addEventListener('pageshow', () => {
      leaving = false;
      document.documentElement.classList.remove('dt-gifting-is-leaving');
      initMotion();
    });
  }

  initMotion();
})();
